import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { saveAs as exportedSaveAs } from 'file-saver';
import { environment } from '../../../../environments/environment';
import { ApiService } from '../../../api.service';

@Component({
  selector: 'app-pricelist-download',
  templateUrl: './pricelist-download.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./pricelist-download.component.scss'],
})
export class PricelistDownloadComponent implements OnInit {
  private api = inject(ApiService);
  private routerService = inject(Router);
  private http = inject(HttpClient);

  [x: string]: any;

  ngOnInit() {
    this.http
      .get(`${environment.api}users/pricelist`, {
        responseType: 'blob',
      })
      .subscribe((data: any) => {
        const blob = new Blob([data], { type: data.type });
        exportedSaveAs(blob, 'pricelist');
        this.routerService.navigate(['/']);
      });
  }
}
